module.exports = __webpack_public_path__ + "static/media/portero.3119f5ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/alternaria_papa/preventiva/portero.png
// module id = 1994
// module chunks = 3